<template>
  <setting-account-mail-config
    @submit="update"
  />
</template>

<script>
import SettingAccountMailConfig from '@/components/organisms/SettingAccountMailConfig'
export default {
  components: {
    SettingAccountMailConfig
  },
  methods: {
    update (value) {
      this.$http.secured.put('/account/mail/edit/settings', value).then(response => {
        this.$toasted.global.success({ message: 'メール受信設定を変更しました。' })
      })
    }
  }
}
</script>
